import axios from "axios";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../utils/consts";
import { parseAxiosError } from "../../utils/response";
import Logo from "../elements/logo/Logo";
import Notification from "../elements/notification/Notification";
import ForgotPasswordForm from "./ForgotPasswordForm";

import { StyledLoginFormHead, StyledLoginFormWrapper, StyledLoginWrapper, StyleFormTitle } from "../login/styledLogin";

const ForgotPasswordContainer = () => {

  const { t } = useTranslation("forgotPasswordPage");
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    let data = {
      email: event.target.email.value
    };

    axios.post("/api/forgot-password", data).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_CREATED) {
        setNotification({
          visible: true,
          type: "success",
          message: response.data.success
        });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setLoading(false);
    });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledLoginWrapper>
        <Helmet>
          <title>{t("forgotPassword.metaTitle")} • eXsoft.io</title>
        </Helmet>
        <Logo className="logo" />
        <StyledLoginFormWrapper>
          <React.Fragment>
            <StyledLoginFormHead>
              <StyleFormTitle as="h2">
                {t("forgotPassword.title")}
              </StyleFormTitle>
            </StyledLoginFormHead>
            <ForgotPasswordForm t={t} handleSubmit={handleSubmit} loading={loading} />
          </React.Fragment>
        </StyledLoginFormWrapper>
      </StyledLoginWrapper>
    </>
  );
};

export default ForgotPasswordContainer;